export default "__VITE_ASSET__57a993bf__"